const EXPECTED_QUERY_PARAMS = {
  BOOKING_OFFER_ID: 'bookingOfferId',
  BOOKING_STEP: 'bookingStep',
  BOOKING_TYPE: 'bookingType',
}

const expectedQueryParamNames = Object.values(EXPECTED_QUERY_PARAMS)

export { EXPECTED_QUERY_PARAMS, expectedQueryParamNames }
